import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "basicSetting"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      rules: _vm.rules,
      model: _vm.dataForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.shopName"),
      prop: "storeName"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 100,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.storeName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "storeName", $$v);
      },
      expression: "dataForm.storeName"
    }
  })], 1), _c("a-form-model-item", [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t("basicSettings.operateType")))]), !_vm.dataForm.operateType && _vm.dataForm.operateType != 0 ? _c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true
    }
  }) : _vm._e(), _vm.dataForm.operateType == 0 ? _c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true,
      value: _vm.$t("basicSettings.operateTypezero")
    }
  }) : _vm._e(), _vm.dataForm.operateType == 1 ? _c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true,
      value: _vm.$t("basicSettings.operateTypeOne")
    }
  }) : _vm._e(), _vm.dataForm.operateType == 2 ? _c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true,
      value: _vm.$t("basicSettings.operateTypeTwo")
    }
  }) : _vm._e(), _vm.dataForm.operateType == 3 ? _c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true,
      value: _vm.$t("basicSettings.operateTypeThree")
    }
  }) : _vm._e()], 1), _vm.currencySymbolList.length > 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.currencySymbol")
    }
  }, [_c("a-select", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.currencySymbol,
      callback: function callback($$v) {
        _vm.currencySymbol = $$v;
      },
      expression: "currencySymbol"
    }
  }, _vm._l(_vm.currencySymbolList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: "Icon"
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      name: "file",
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      "before-upload": _vm.beforeUpload,
      data: _vm.updateData
    },
    on: {
      change: _vm.handleChangeIcon
    }
  }, [_vm.dataForm.storeIcon ? _c("img", {
    staticStyle: {
      width: "102px",
      height: "102px"
    },
    attrs: {
      src: _vm.systemSettingData.imageHost + _vm.dataForm.storeIcon,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loadingIcon ? "loading" : "plus"
    }
  })], 1)]), _c("div", {
    staticStyle: {
      color: "#f5222f",
      "line-height": "normal"
    }
  }, [_vm._v(_vm._s(_vm.$t("basicSettings.tipsForUploadingPicture", {
    size: "150*150",
    uploadLimit: _vm.uploadLimit
  })))])], 1), _c("a-form-model-item", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };